import styled from "styled-components";
import { media } from "../../globalStyles";

export const Container = styled.div`
  width: 100%;
  background-color: #172029ff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(221, 221, 221) !important;
`;
export const ExpenseWrapper = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  padding: 12px 20px;
  border-top: 2px solid #614e20ff;
  border-bottom: 2px solid #614e20ff;
`;

export const DetailModule = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  margin-top: 50px;
  background-color: #0f1923ff;
  border: 4.5px solid #081019ff;
`;

export const DetailContentWrapper = styled.div`
  width: 95%;
  display: flex;
  flex-wrap:wrap;
  align-items: center;
  justify-content: space-between;
  h1 {
    font-size: 18px !important;
    font-weight: 400;
  }
  strong {
    color: #8c734b;
  }

  select{
    width:auto;
  }

  ${media.mobile}{
    h1{
      font-size: 15px !important;
    }

    Select{
      width: auto;
      height: 25px;
      font-size: 13px;
      margin:5px;
    }
  }
`;

export const Item = styled.div`
  width: 85%;
  height: 55px;
  display: flex;
  align-items: center;
  /* margin-top: 30px;
  margin-left: 30px; */
`;

export const DetailGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
  margin-top: 30px;
`;

export const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 10px;
  min-width:35%;
  ${media.mobile}{
    width:90%;
  }
`;

export const UlWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: none;
  width: 90%;
  ul {
    margin: 0px;
    padding: 0px;
    width: 100%;
  }
  li {
    list-style: none;
    padding: 4px;
  }

  ${media.mobile}{

    font-size: 13px;
  }
`;

export const ItemTopWrapper = styled.div`
  width: 100%;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  h1 {
    font-size: 20px;
    font-weight: 390;
  }
`;
export const Select = styled.select`
  width: 20%;
  height: 35px;
  background: white;
  color: gray;
  padding-left: 5px;
  font-size: 14px;
  border: none;
  margin-left: 10px;

  option {
    color: black;
    background: white;
    display: flex;
    white-space: pre;
    min-height: 20px;
    padding: 0px 2px 1px;
  }
`;

export const TimeContainer = styled.div`
  width: 98%;
  display: flex;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  border-top: 1px solid #614e20ff;
  background-color: none;
  padding: 25px 10px;
`;

export const TimeInputContianer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1.4;
`;

export const TimeInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
`;
export const Block = styled.div`
  display: flex;
  gap: 15px;
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
`;
export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: ${({ variant }) => {
    return variant === "row" ? "row" : "column";
  }};
  align-items: ${({ variant }) => {
    return variant === "row" ? "flex-end" : "flex-start";
  }};
  gap: 10px;

  input {
    width: ${({ width }) => {
      return width === "short" ? "100px" : "180px";
    }};
    height: 28px;
  }
`;

export const TimeTableContainer = styled.div`
  flex: 2;
  height: 90%;
`;

export const Expensecontainer = styled.div`
  width: 98%;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  border-top: 1px solid #614e20ff;
  background-color: none;
  padding: 5px 10px;
  padding-bottom: 20px;
`;

export const ExpenseHeader = styled.div`
  height: 60px;
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
// export const CommentHeader = styled.div`
//   height: auto;
//   width: 100%;
//   /* margin-bottom: 10px; */
//   display: flex;
//   /* align-items: center; */
//   /* justify-content: space-between; */
// `;

export const Icon = styled.div`
  width: 60px;
  margin: 0px;
  padding: 0px;
  gap: 0px;
  display: flex;
  align-items: center;
`;

export const CommentContainer= styled.div`

  width: 98%;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  border-top: 1px solid #614e20ff;
  background-color: none;
  padding: 5px 10px;
  padding-bottom: 20px;

`

export const CommentHeader = styled.div`
display: flex;
justify-content: flex-start;
margin-top: 20px;
`

export const CommentBody = styled.div`
display: flex;
justify-content: flex-start;
margin-top: 20px;
textarea{
  width:100%;
  height: 140px;
  border-radius: 6px;
  padding:5px;
}
`

export const CommentPost = styled.div`
display: flex;
justify-content: flex-end;
margin-top: 10px;


`
